module.exports = __webpack_public_path__ + "img/V2.38c0c6ff.jpg";